import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Icon } from '@/lib/icons';
import type { ThemeImportsStatusFilter } from './use-theme-imports';

interface ThemeImportsFiltersProps {
  filterBySectorLabel: string;
  allSectorsLabel: string;
  filterByStatusLabel: string;
  allStatusesLabel: string;
  activeLabel: string;
  inactiveLabel: string;
  searchPlaceholder: string;
  sectors: string[];
  sector: string;
  status: ThemeImportsStatusFilter;
  search: string;
  onSectorChange: (sector: string) => void;
  onStatusChange: (status: ThemeImportsStatusFilter) => void;
  onSearchChange: (search: string) => void;
}

export function ThemeImportsFilters({
  filterBySectorLabel,
  allSectorsLabel,
  filterByStatusLabel,
  allStatusesLabel,
  activeLabel,
  inactiveLabel,
  searchPlaceholder,
  sectors,
  sector,
  status,
  search,
  onSectorChange,
  onStatusChange,
  onSearchChange,
}: ThemeImportsFiltersProps) {
  return (
    <section className="pt-7">
      <div className="flex flex-wrap items-center gap-4">
        <div className="w-[200px]">
          <Select value={sector} onValueChange={onSectorChange}>
            <SelectTrigger className="border-border/40 bg-muted/20 text-foreground/80">
              <SelectValue placeholder={filterBySectorLabel} />
            </SelectTrigger>
            <SelectContent className="border-border/40 bg-card">
              <SelectItem value="all">{allSectorsLabel}</SelectItem>
              {sectors.map((name) => (
                <SelectItem key={name} value={name}>
                  {name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="w-[200px]">
          <Select
            value={status}
            onValueChange={(value) => {
              if (value === 'all' || value === 'active' || value === 'inactive') {
                onStatusChange(value);
              }
            }}
          >
            <SelectTrigger className="border-border/40 bg-muted/20 text-foreground/80">
              <SelectValue placeholder={filterByStatusLabel} />
            </SelectTrigger>
            <SelectContent className="border-border/40 bg-card">
              <SelectItem value="all">{allStatusesLabel}</SelectItem>
              <SelectItem value="active">{activeLabel}</SelectItem>
              <SelectItem value="inactive">{inactiveLabel}</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="relative w-[280px]">
          <Icon name="search" className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground/70" />
          <Input
            type="search"
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder={searchPlaceholder}
            className="border-border/40 bg-muted/20 py-2 pl-9 text-sm text-foreground/80 placeholder:text-muted-foreground/70"
          />
        </div>
      </div>
    </section>
  );
}